module.exports = __webpack_public_path__ + "media/pricing/personalized-demo-c08d7c6e.jpg";